<mat-list class="management-list">
    <mat-list-item
        *ngFor="let item of (items$ | async); let i = index"
        [ngClass]="{'selected-bold': item.tag === selectedItem?.tag}"
        [contextMenu]="basicMenu" [contextMenuValue]="item"
    >
        <button
            [attr.data-testid]="item.name + '_option'"
            mat-button
            (click)="onItemSelected(item)"
        >
            <span class="bull">&#8226;</span>
            <span class="align-text" [ngClass]="{'item-disabled': item.disabled}">
                {{ item.name }} <span [ngStyle]="{ fontSize: '13px' }" *ngIf="item?.tag && (showTags$ | async)">- {{ item?.tag }}</span>
            </span>
        </button>
        <context-menu #basicMenu [disabled]="isReadOnly">
            <ng-template
                *ngFor="let action of contextMenuActions" contextMenuItem let-item
                [visible]="action.visible && action.visible(item.source)"
                [disabled]="!action.enabled && !action.enabled(item.source) && disableContextActions"
                [divider]="action.divider" (execute)="action.click && action.click(item.source)"
            >
                <span
                    [attr.data-testid]="action.text(item.source) + '_button'"
                >{{ action.text && action.text(item.source) }}</span>
                <mat-icon
                    [attr.data-testid]="action.text(item.source) + '_icon'"
                >{{ action.icon && action.icon(item.source) }}</mat-icon>
            </ng-template>
        </context-menu>
    </mat-list-item>
</mat-list>
